/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./BusinessesGivingBack.css";

// Individual · "peers". The shops funding the same causes, and what they are
// selling for them right now — giving that costs the individual nothing extra.
class BusinessesGivingBack extends Component {
  render() {
    const vm = this.props.vm;
    const b = vm.brands;
    return (
      <div className="Marketplace-Brands">
        <div className="Marketplace-Brands-main">
          {b.campaigns.map((c) => (
            <div className="Marketplace-card Marketplace-Brands-campaign" key={c.id}>
              <div className="Marketplace-Brands-shot">
                <span>
                  {vm.m.brandProductShot}
                  <br />
                  {c.biz}
                </span>
              </div>
              <div className="Marketplace-Brands-body">
                <div className="Marketplace-Brands-bizRow">
                  <div className="Marketplace-mono Marketplace-mono--sm">{c.mono}</div>
                  <span className="Marketplace-Brands-bizName">{c.biz}</span>
                  <span className="Marketplace-Brands-rule">{c.rule}</span>
                  <span className="Marketplace-Brands-ends">{vm.fill(vm.m.brandEnds, { date: c.ends })}</span>
                </div>
                <div className="Marketplace-Brands-title">{c.title}</div>
                <p className="Marketplace-Brands-copy">{c.body}</p>
                <div className="Marketplace-bar">
                  <div className="Marketplace-barFill" style={{ width: c.w }} />
                </div>
                <div className="Marketplace-Brands-raised">{c.raised}</div>
                <div className="Marketplace-Brands-buyRow">
                  <span className="Marketplace-Brands-price">{c.price}</span>
                  <div
                    className={"Marketplace-btnPrimary" + (c.bought ? " Marketplace-btn--done" : "")}
                    onClick={c.buy}
                  >
                    {c.buyLabel}
                  </div>
                  <span className="Marketplace-Brands-give">{c.give}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="Marketplace-Brands-side">
          <div className="Marketplace-card">
            <div className="Marketplace-cardTitle">{vm.m.basketTitle}</div>
            <div className="Marketplace-Brands-basketTotal">{b.basketTotal}</div>
            <div className="Marketplace-Brands-basketNote">{b.basketNote}</div>
            <div className="Marketplace-btnGhost Marketplace-btn--block Marketplace-btn--inert">
              {vm.m.basketCheckout}
            </div>
          </div>
          <div className="Marketplace-card">
            <div className="Marketplace-cardTitle">{vm.m.backersTitle}</div>
            <div className="Marketplace-Brands-backers">
              {b.backers.map((x) => (
                <div className="Marketplace-Brands-backer" key={x.id}>
                  <div className="Marketplace-mono Marketplace-mono--sm">{x.mono}</div>
                  <div className="Marketplace-Brands-backerInfo">
                    <div className="Marketplace-Brands-backerName">{x.name}</div>
                    <div className="Marketplace-Brands-backerLine">{x.line}</div>
                  </div>
                  <span className="Marketplace-Brands-backerGiven">{x.given}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BusinessesGivingBack.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default BusinessesGivingBack;
